import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {restoreUser} from 'src/openapi/admin/apis/UserLifecycleApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';

type Props = {
    userId: number,
    onSuccess: () => void,
};

export const useRestoreUser = ({userId, onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((options?: ActionOptions) => apiDispatch(
        restoreUser({userId, reason: options?.reason}),
    ), [userId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess});
};
